import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import {
  Segment,
  Grid,
  Table,
  Dimmer,
  Loader,
  Icon,
  Label,
  Input,
  Menu,
  Button,
  Dropdown,
} from 'semantic-ui-react'

import firebase from '../../config/firebase'
import utils from '../../utils'

import RestaurantRow from '../../components/restaurants/row'
import DynamicFee from '../../components/restaurants/dynamicFee'
import Loading from '../../components/common/loading'
import RestaurantActions from '../../reducers/restaurantReducer'
import DynamicFeeActions from '../../reducers/dynamicFeeReducer'
import MenuActions from '../../reducers/menuReducer'
import RestaurantByCategory from '../../components/restaurants/restaurantByCategory'
import OnlinePaymentTab from './OnlinePaymentTab'

class Restaurants extends Component {
  state = {
    tab: 'list',
    restaurantTab: 'publish',
    updatingListingOrder: false,
    categoryData: {},
    activeCategoryTab: null,
    restaurantByCategoryData: {},
    fetchingRestaurantCategory: false,
    searchText: '',
    merchantType: 'all',
    isSortingByDistance: false,
    isShuffleSameDeliveryFee: false,
    loadingConfig: true,
  }

  componentDidMount() {
    const { loaded, fetchRestaurants, fetchMenus, fetchSelectedCategories, syncDynamicFees } = this.props
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'list'

    if (!loaded) {
      fetchRestaurants()
    }

    if (tab === 'category') {
      this.handleItemClick('all')
    }

    fetchMenus()

    fetchSelectedCategories()
    syncDynamicFees()
    this.getSortingOptionConfig()
    this.setState({ tab })
  }


  componentWillReceiveProps(nextProps) {
    const { menus, publishedRestaurants } = this.props

    if (menus !== nextProps.menus) {
      this.setCategoryData(nextProps.menus)
    }

    if (publishedRestaurants !== nextProps.publishedRestaurants) {
      this.setPublishedRestoToCategory(nextProps.publishedRestaurants)
    }
  }

  getSortingOptionConfig = () => {

    this.setState({ loadingConfig: true })
    const restRef = firebase.database().ref(`configs`)

    restRef.once('value', snapshot => {
      const data = snapshot.val() || {}

      this.setState({
        loadingConfig: false,
        isSortingByDistance: data.is_sort_by_distance,
        isShuffleSameDeliveryFee: data.is_shuffle_same_delivery_fee,
      })
    })
  }

  onHandleChangeText = text => {
    if (text !== '\\') {
      this.setState({ searchText: text })
    } else {
      return
    }
  }

  setPublishedRestoToCategory = publishedRestaurants => {
    const { restaurantByCategoryData } = this.state
    const allRestaurant = {}

    _.map(publishedRestaurants, (restaurant, restKey) => {
      allRestaurant[restKey] = restaurant
    })

    this.setState({
      restaurantByCategoryData: {
        ...restaurantByCategoryData,
        all: allRestaurant,
      },
    })
  }

  handleSortByDistance = (menuId, categoryKey, category) => {
    this.setState({ loadingConfig: true })

    const {  categoryData } = this.state
    const updates = {}
    updates[`menus/${menuId}/categories/${categoryKey}/is_sort_by_distance`] = category.is_sort_by_distance

    firebase.database().ref().update(updates).then(err => {
      if (err) alert(err)

      this.setState({
        loadingConfig: false,
        categoryData: { ...categoryData, [categoryKey]: category }
      })
    })
  }

  handleShuffleSameDeliveryFeeByCategory = (menuId, categoryKey, category) => {
    this.setState({ loadingConfig: true })

    const {  categoryData } = this.state
    const updates = {}
    updates[`menus/${menuId}/categories/${categoryKey}/is_shuffle_same_delivery_fee`] = category.is_shuffle_same_delivery_fee

    firebase.database().ref().update(updates).then(err => {
      if (err) alert(err)

      this.setState({
        loadingConfig: false,
        categoryData: { ...categoryData, [categoryKey]: category }
      })
    })
  }

  handleUpdateShuffleSameDeliveryFeeConfig = isShuffleSameDeliveryFee => {
    this.setState({ loadingConfig: true })
    const updates = {}
    updates[`configs/is_shuffle_same_delivery_fee`] = isShuffleSameDeliveryFee

    firebase.database().ref().update(updates).then(err => {
      if (err) alert(err)

      this.setState({
        isShuffleSameDeliveryFee,
        loadingConfig: false
      })
    })
  }

  handleUpdateSortByDistanceConfig = isSortingByDistance => {
    this.setState({ loadingConfig: true })
    const updates = {}
    updates[`configs/is_sort_by_distance`] = isSortingByDistance

    firebase.database().ref().update(updates).then(err => {
      if (err) alert(err)

      this.setState({
        isSortingByDistance,
        loadingConfig: false
      })
    })
  }

  getRestaurantByCategory = categoryKey => {
    const { auth } = this.props
    const { restaurantByCategoryData } = this.state
    const { region = utils.constants.REGION.PHNOM_PENH } = auth
    this.setState({ fetchingRestaurantCategory: true })

    const restRef = firebase
      .database()
      .ref('/restaurants')
      .orderByChild(`categories/${region}/${categoryKey}`)
      .equalTo(true)

    restRef.once('value', snapshot => {
      this.setState({
        fetchingRestaurantCategory: false,
        restaurantByCategoryData: {
          ...restaurantByCategoryData,
          [categoryKey]: snapshot.val() || undefined,
        },
      })
    })
  }

  setCategoryData = menus => {
    const allCategoriesName = {}
    _.map(menus, (menu, menuKey) => {
      _.map(menu.categories, (category, categoryKey) => {
        allCategoriesName[categoryKey] = { ...category, menu_key: menuKey }
      })
    })

    this.setState({ categoryData: allCategoriesName })
  }

  handleItemClick = categoryKey => {
    const { publishedRestaurants } = this.props

    this.setState({ activeCategoryTab: categoryKey }, () => {
      if (categoryKey !== 'all') {
        this.getRestaurantByCategory(categoryKey)
      } else {
        this.setPublishedRestoToCategory(publishedRestaurants)
      }
    })
  }

  switchTab = tab => {
    const { history } = this.props
    const queryString = tab ? `?tab=${tab}` : ''

    history.push(`/restaurants${queryString}`)

    if (tab === 'category') {
      this.setState({ tab }, () => {
        this.handleItemClick('all')
      })
    } else {
      this.setState({ tab })
    }
  }

  getRestaurantByStatus = status => {
    const { merchantType } = this.state
    const { publishedRestaurants, draftedRestaurants } = this.props
    const restaurants = status === 'publish' ? publishedRestaurants : draftedRestaurants

    if (merchantType === 'all') return restaurants

    return restaurants.filter(res => res.merchant_type === merchantType)
  }

  renderRestaurantTab = (type, restaurantCount) => {
    const { restaurantTab } = this.state

    return (
      <Menu.Item
        name={type}
        active={restaurantTab === type}
        onClick={() => this.setState({ restaurantTab: type })}
      >
        {`${_.capitalize(type)}ed`}
        <Label circular style={{ marginLeft: 6 }}>
          {restaurantCount}
        </Label>
      </Menu.Item>
    )
  }

  renderRestaurantRows = merchants => {
    const { searchText  } = this.state
    const searchedMerchants = merchants.filter(merchant => {
      const merchantName = (merchant.name || '').toLowerCase()

      return merchantName.includes(searchText.toLowerCase())
    })

    const sortedMerchants = _.sortBy(searchedMerchants, merchant => (merchant.name || '').toLowerCase())

    return sortedMerchants.map((restaurant, index) => (
      <RestaurantRow
        key={restaurant.key}
        data={restaurant}
        fireKey={restaurant.key}
        listNumber={index + 1}
      />
    ))
  }

  renderMerchantTypeSelect = () => {
    const { merchantType } = this.state
    const merchantTypes = [
      { text: 'All Merchants', value: 'all' },
      { text: 'Mart', value: 'mart' },
      { text: 'F & B', value: 'f-and-b' },
    ]

    return (
      <Dropdown
        style={{ width: 150, marginRight: 3 }}
        options={merchantTypes}
        value={merchantType}
        onChange={ (e, data) => this.setState({ merchantType: data.value }) }
        selection
      />
    )
  }

  renderTable = () => {
    const { restaurantTab } = this.state
    const publishMerchants = this.getRestaurantByStatus('publish')
    const draftMerchants = this.getRestaurantByStatus('draft')
    const displayMerchants = restaurantTab === 'publish' ? publishMerchants : draftMerchants

    return (
      <div>
        <Menu pointing secondary style={{ marginTop: 16 }}>
          {this.renderRestaurantTab('publish', publishMerchants.length)}
          {this.renderRestaurantTab('draft', draftMerchants.length)}
        </Menu>
        <Segment style={{ height: 'calc(100vh - 265px)', overflow: 'auto' }}>
          <Table basic="very">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Commission</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Tier</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Type</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderRestaurantRows(displayMerchants)}</Table.Body>
          </Table>
        </Segment>
      </div>
    )
  }

  renderSelectedCategoriesTab = () => {
    const {
      fetchingRestaurantCategory,
      updatingListingOrder,
      categoryData,
      activeCategoryTab,
    } = this.state
    const { selectedCategories } = this.props

    if (_.size(selectedCategories) > 0) {
      const menuItems = _.map(selectedCategories, (category, categoryKey) => {
        const name = _.get(categoryData, [categoryKey, 'name'], 'N/A')

        return (
          <Menu.Item
            disabled={fetchingRestaurantCategory || updatingListingOrder}
            key={categoryKey}
            name={name}
            active={activeCategoryTab === categoryKey}
            onClick={() => this.handleItemClick(categoryKey)}
          />
        )
      })

      return (
        <Menu pointing vertical>
          <Menu.Item key="header" style={{ background: '#eeeeee' }} header>
            Show on App
          </Menu.Item>
          {menuItems}
        </Menu>
      )
    }

    return null
  }

  renderAllCategoriesTab = () => {
    const {
      fetchingRestaurantCategory,
      updatingListingOrder,
      categoryData,
      activeCategoryTab,
    } = this.state
    const { selectedCategories } = this.props
    const selectedCategoryKeys = Object.keys(selectedCategories)

    if (_.size(categoryData) > 0) {
      const menuItems = _.map(categoryData, (category, categoryKey) => {
        if (!_.includes(selectedCategoryKeys, categoryKey)) {
          return (
            <Menu.Item
              disabled={fetchingRestaurantCategory || updatingListingOrder}
              key={categoryKey}
              name={categoryData[categoryKey].name}
              active={activeCategoryTab === categoryKey}
              onClick={() => this.handleItemClick(categoryKey)}
            />
          )
        }

        return null
      })

      return (
        <Menu pointing vertical>
          <Menu.Item key="header" style={{ background: '#eeeeee' }} header>
            Other Category
          </Menu.Item>
          {menuItems}
        </Menu>
      )
    }

    return null
  }

  renderRestaurantByCategory = () => {
    const {
      fetchingRestaurantCategory,
      restaurantByCategoryData,
      updatingListingOrder,
      activeCategoryTab,
      categoryData,
      isSortingByDistance,
      isShuffleSameDeliveryFee,
    } = this.state

    const { publishedRestaurants, auth } = this.props

    if (activeCategoryTab) {
      return (
        <RestaurantByCategory
          auth={auth}
          categoryKey={activeCategoryTab}
          restaurants={restaurantByCategoryData[activeCategoryTab]}
          allPublishedRestaurants={publishedRestaurants}
          allCategoryData={categoryData}
          setUpdateListing={val => this.setState({ updatingListingOrder: val })}
          loading={fetchingRestaurantCategory}
          refreshData={this.getRestaurantByCategory}
          updating={updatingListingOrder}
          updateSelectCategory={this.handleSortByDistance}
          isSortingByDistance={isSortingByDistance}
          isShuffleSameDeliveryFee={isShuffleSameDeliveryFee}
          handleShuffleSameDeliveryFeeByCategory={this.handleShuffleSameDeliveryFeeByCategory}
          handleUpdateShuffleSameDeliveryFeeConfig={this.handleUpdateShuffleSameDeliveryFeeConfig}
          handleUpdateSortByDistanceConfig={this.handleUpdateSortByDistanceConfig}
        />
      )
    }

    return null
  }

  renderCategoryRestaurant = () => {
    const { updatingListingOrder, fetchingRestaurantCategory, activeCategoryTab } = this.state

    return (
      <div className="restaurant-category-wrapper">
        <div className="restaurant-category-tab">
          <div>
            <Menu pointing vertical>
              <Menu.Item
                disabled={fetchingRestaurantCategory || updatingListingOrder}
                key="all"
                name="All Restaurants"
                active={activeCategoryTab === 'all'}
                onClick={() => this.handleItemClick('all')}
              />
            </Menu>
          </div>
          <div style={{ margin: 5 }} />
          <div>{this.renderSelectedCategoriesTab()}</div>
          <div style={{ margin: 5 }} />
          <div>{this.renderAllCategoriesTab()}</div>
        </div>
        <div className="restaurant-category-tab-content">
          <Dimmer active={fetchingRestaurantCategory} inverted>
            <Loader />
          </Dimmer>
          {this.renderRestaurantByCategory()}
        </div>
      </div>
    )
  }

  renderFilter = () => {
    const { updatingListingOrder, searchText } = this.state

    return (
      <React.Fragment>
        <Link to="/restaurants/new" style={{ float: 'right' }}>
          <Button icon color="black" disabled={updatingListingOrder}>
            <Icon name="add" />
          </Button>
        </Link>
        <div style={{ float: 'right', marginRight: 10 }}>
          {this.renderMerchantTypeSelect()}
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={e => this.onHandleChangeText(e.target.value)}
          />
        </div>
      </React.Fragment>
    )
  }

  renderFee = () => {
    const { saveDynamicFee, deleteDynamicFee, dynamicFees, addingDynamicFee, dynamicFeeLoading } = this.props

    return (
      <DynamicFee
        dynamicFees={dynamicFees}
        saveDynamicFee={saveDynamicFee}
        addingDynamicFee={addingDynamicFee}
        dynamicFeeLoading={dynamicFeeLoading}
        deleteDynamicFee={deleteDynamicFee}
      />
    )
  }

  render() {
    const { loading, restaurants } = this.props
    const { updatingListingOrder, tab, loadingConfig } = this.state

    let tabToRender = null

    if (tab === 'list') {
      tabToRender = this.renderTable()
    } else if (tab === 'category') {
      tabToRender = this.renderCategoryRestaurant()
    } else if (tab === 'fee') {
      tabToRender = this.renderFee()
    } else if (tab === 'online-payment') {
      tabToRender = <OnlinePaymentTab restaurants={restaurants} />
    }

    return (
      <div>
        <Loading active={loading || loadingConfig} />
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <Button.Group>
                <Button
                  disabled={updatingListingOrder}
                  secondary={tab === 'list'}
                  onClick={() => this.switchTab('list')}
                >
                  List Restaurants
                </Button>
                <Button.Or />
                <Button
                  disabled={updatingListingOrder}
                  secondary={tab === 'category'}
                  onClick={() => this.switchTab('category')}
                >
                  Category/Arrangement
                </Button>
                <Button.Or />
                <Button
                  disabled={updatingListingOrder}
                  secondary={tab === 'online-payment'}
                  onClick={() => this.switchTab('online-payment')}
                >
                  Online Payment
                </Button>
                <Button.Or />
                <Button
                  disabled={updatingListingOrder}
                  secondary={tab === 'fee'}
                  onClick={() => this.switchTab('fee')}
                >
                  Dynamic Fee
                </Button>
              </Button.Group>
              {tab === 'list' && this.renderFilter()}
              {tabToRender}
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ restaurants, dynamicFees, menus, auth }) => ({
  auth: auth.data,
  loading: restaurants.loading,
  loaded: restaurants.loaded,
  restaurants: restaurants.data,
  menus: menus.data,
  selectedCategories: menus.selectedCategories,
  dynamicFees: dynamicFees.dynamicFees,
  dynamicFeeLoading: dynamicFees.dynamicFeeLoading,
  addingDynamicFee: dynamicFees.addingDynamicFee,
  publishedRestaurants: _.filter(restaurants.data, restaurant => restaurant.status === 'publish'),
  draftedRestaurants: _.filter(
    restaurants.data,
    restaurant => restaurant.status !== 'publish' && restaurant.status !== 'archived'
  ),
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  fetchMenus: MenuActions.fetchMenusRequest,
  fetchSelectedCategories: MenuActions.fetchSelectedCategoriesRequest,
  saveDynamicFee: DynamicFeeActions.saveDynamicFee,
  deleteDynamicFee: DynamicFeeActions.deleteDynamicFee,
  syncDynamicFees: DynamicFeeActions.syncDynamicFees,
}

export default connect(
  mapState,
  mapDispatch
)(Restaurants)



// WEBPACK FOOTER //
// ./src/containers/restaurants/index.js